import React, { forwardRef } from "react";
import Button, { ButtonProps } from "@mui/material/Button";
import { useTheme } from "@/contexts/theme/useTheme";
import { PrimaryButton, type ThemeVariantOverride } from "./primary-button";
import { StyledSecondaryButton } from "./secondary-button-styled";

export type SecondaryButtonProps = ButtonProps & {
  themeAsPrimary?: boolean;
  themeVariant?: ThemeVariantOverride;
};

/**
 * Theme-aware SecondaryButton. When a client theme is active, themeAsPrimary renders as PrimaryButton.
 * Pass themeVariant to control the primary variant (e.g. themeAsPrimary themeVariant="outlined").
 */
const SecondaryButton = forwardRef<HTMLButtonElement, SecondaryButtonProps>(
  function SecondaryButton({ themeAsPrimary, ...props }, ref) {
    const { currentTheme } = useTheme();
    const isHpClient = currentTheme === "hp-client";
    const labelWrap = isHpClient ? (
      <span data-button-label>{props.children}</span>
    ) : (
      props.children
    );

    if (isHpClient && themeAsPrimary) {
      return <PrimaryButton ref={ref} {...props} />;
    }

    return (
      <StyledSecondaryButton
        ref={ref}
        data-sentence-case={isHpClient || undefined}
        {...props}
      >
        {labelWrap}
      </StyledSecondaryButton>
    );
  }
);

export { SecondaryButton };
